import deltas from "../../actions/deltas";
import createModalIdStateReducer from "../../helpers/createModalIdStateReducer";

const {SET_ENROLMENT_MODAL_ID_STATE} = deltas.actionTypes;

export default createModalIdStateReducer(SET_ENROLMENT_MODAL_ID_STATE);
